/**
 * useDocumentTitle
 * ================
 * Sets the browser tab title, re-applying whenever `title` changes (e.g. once
 * org branding resolves). Falsy values are ignored so a page never blanks the
 * tab while the brand is still loading.
 *
 * No restore-on-unmount: the next mounted view (auth page or the authenticated
 * DashboardLayout) always sets its own title, so restoring here would only
 * flash the stale static shell title in between.
 */

import { useEffect } from 'react';

export const useDocumentTitle = (title) => {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
};

export default useDocumentTitle;
